
<template>
  <div class="loader">
    <div class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>

  .loader {
    position: absolute;
    background: $background-color;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    height: 100vh;
    display: grid;
    height: 100vh;
    margin: 0;
    place-items: center center;
    z-index: 99999;
  }

  .spinner {
    width: 40px;
    height: 40px;

    position: relative;
    margin: auto;
  }

  .double-bounce1, .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: $color-highlight;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
    animation: sk-bounce 2.0s infinite ease-in-out;
  }

  .double-bounce2 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
  }

  @-webkit-keyframes sk-bounce {
    0%, 100% { -webkit-transform: scale(0.0) }
    50% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bounce {
    0%, 100% {
      transform: scale(0.0);
      -webkit-transform: scale(0.0);
    } 50% {
      transform: scale(1.0);
      -webkit-transform: scale(1.0);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue